import { Controller } from 'stimulus';

export default class extends Controller {
  static values = { autoOpen: Boolean };

  connect() {
    this.boundOnClose = this.#onClose.bind(this);
    this.element.addEventListener('close', this.boundOnClose);

    if (this.autoOpenValue) {
      document.querySelectorAll('dialog[open]').forEach((dialog) => {
        if (dialog !== this.element) {
          dialog.close();
        }
      });
      this.element.showModal();
    }
  }

  disconnect() {
    this.element.removeEventListener('close', this.boundOnClose);
  }

  close() {
    this.element.close();
  }

  #onClose() {
    // Remove from DOM when injected dynamically (appended to body via turbo stream)
    if (this.autoOpenValue) {
      this.element.remove();
    }
  }
}
